import { useState } from "react";
import { GALLERY_FILTERS, GALLERY_ITEMS, SALON, BEFORE_AFTER } from "@/data/content";
import { VorherNachher } from "@/components/VorherNachher";

export default function Galerie() {
  const [filter, setFilter] = useState("Alle");
  const items = filter === "Alle" ? GALLERY_ITEMS : GALLERY_ITEMS.filter((i) => i.category === filter);

  return (
    <div data-testid="page-galerie">
      <section className="py-16 md:py-20 border-b border-[#24211D]/10">
        <div className="max-w-6xl mx-auto px-6">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Vorher / Nachher</span>
          <h1 className="text-[clamp(36px,4.5vw,64px)] leading-tight mb-6">Galerie</h1>
          <p className="text-base text-[#24211D]/80 max-w-2xl leading-relaxed">
            Echte Ergebnisse aus unserem Studio in Glessen – weitere Fotos folgen laufend. Bald auch auf unserem Instagram-Profil.
          </p>
        </div>
      </section>

      {BEFORE_AFTER.length > 0 && (
        <section className="py-14 border-b border-[#24211D]/10 bg-[#F4EFE6]">
          <div className="max-w-6xl mx-auto px-6">
            <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Zum Schieben</span>
            <h2 className="text-3xl md:text-4xl mb-3">Vorher & Nachher</h2>
            <p className="text-xs text-[#24211D]/70 font-sans max-w-xl leading-relaxed mb-8">
              Ziehen Sie den goldenen Punkt mit dem Finger oder der Maus hin und her – und sehen Sie den Unterschied.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {BEFORE_AFTER.map((p, i) => (
                <figure key={i}>
                  <VorherNachher before={p.before} after={p.after} altBefore={p.altBefore} altAfter={p.altAfter} testid={`vorher-nachher-${i}`} />
                  {p.caption && <figcaption className="mt-3 text-xs font-sans text-[#24211D]/70">{p.caption}</figcaption>}
                </figure>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-wrap gap-3 mb-10" role="group" aria-label="Galerie-Filter">
            {GALLERY_FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`filter-${f.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className={`px-5 py-2.5 text-[11px] uppercase tracking-[0.14em] font-sans border transition-colors duration-200 ${
                  filter === f
                    ? "bg-[#B08D57] border-[#B08D57] text-[#FBF8F3]"
                    : "border-[#24211D]/20 text-[#24211D]/70 hover:border-[#B08D57] hover:text-[#B08D57]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="gallery-grid">
            {items.map((item, i) => (
              <figure key={`${item.category}-${i}`} className="border border-[#24211D]/10 bg-[#FFFFFF]" data-testid={`gallery-item-${i}`}>
                <div className="aspect-[3/4] overflow-hidden">
                  <img src={item.src} alt={item.alt} className="w-full h-full object-cover hover:scale-[1.03] transition-transform duration-500" loading="lazy" />
                </div>
                <figcaption className="px-4 py-3 flex items-center justify-between">
                  <span className="text-[10px] uppercase tracking-[0.18em] text-[#B08D57] font-sans">{item.category}</span>
                  <span className="text-[10px] text-[#24211D]/50 font-sans">{item.real ? "Studio Nes" : "Beispielbild"}</span>
                </figcaption>
              </figure>
            ))}
          </div>

          <div className="mt-12 border border-[#24211D]/15 bg-[#F4EFE6] p-8 text-center" data-testid="instagram-hint">
            <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Instagram</span>
            <p className="text-sm text-[#24211D]/80 leading-relaxed max-w-xl mx-auto mb-4">
              Mehr Ergebnisse und Einblicke aus dem Studio gibt es auf unserem Instagram-Profil – schau gerne vorbei und folge uns.
            </p>
            <a href={SALON.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="instagram-link" className="inline-block border border-[#B08D57] text-[#B08D57] hover:bg-[#B08D57] hover:text-[#FBF8F3] px-8 py-3 text-xs uppercase tracking-[0.18em] font-sans transition-colors duration-300">
              {SALON.instagramHandle} auf Instagram
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
